import { call, put, takeLatest } from 'redux-saga/effects'
import { RESOURCE_EMBED_CONFIG_FETCH_REQUESTED, RESOURCE_EMBED_CONFIG_FETCH_SUCCEEDED, RESOURCE_EMBED_CONFIG_FETCH_FAILED} from "../actionTypes"
import { getResourceEmbedConfig } from '../../services/powerBIService'

function* fetchResourceEmbedConfig(action: any){
    try {
        const config = yield call(getResourceEmbedConfig, action.payload.resourceId, action.payload.bearerToken)
        yield put({type: RESOURCE_EMBED_CONFIG_FETCH_SUCCEEDED, payload: {config: config}})
    } catch (error) {
        yield put({type: RESOURCE_EMBED_CONFIG_FETCH_FAILED, payload: {embedConfigMessage: error.message}});
    }
}

function* resourcesEmbedConfigSaga(){
    yield takeLatest(RESOURCE_EMBED_CONFIG_FETCH_REQUESTED, fetchResourceEmbedConfig)
}

export default resourcesEmbedConfigSaga